import React from 'react';
import { section, sectionClip, sectionHeader } from './styles.sass';

export default function LandingPageSection({
  title,
  subtitle,
  children,
  headerBgColor = '#292F36',
  bgColor = 'transparent',
  backgroundStyle = {},
}) {
  return (
    <div
      className={section}
      style={{ ...backgroundStyle, backgroundColor: bgColor }}
    >
      <div className={sectionClip}>
        <div
          className={sectionHeader}
          style={{ backgroundColor: headerBgColor }}
        >
          <h2>{title}</h2>
          {subtitle && <p>{subtitle}</p>}
        </div>
        {children}
      </div>
    </div>
  );
}
